import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
import { AccountingFormTypes } from "models/formTypes";
//#endregion
//#region components
import { ChartContainer, useFilterContext } from "components/common";
import { useFinancialReportService } from "serviceHooks";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
//#endregion

const BalanceReportAssetsSummaryPieChart: React.FC = () => {
  const financialReportService = useFinancialReportService();
  const { filter } = useFilterContext<AccountingFormTypes.FinancialReportFilter>();

  return filter?.monthRange?.start && filter?.monthRange?.end ? (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.BalanceReportAssetsSummaryPieWidget}
      doughnutChartLegendType={ChartEnums.LegendType.WITH_VALUES}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.DEFAULT}
      showTotal
      filterToAPIHandler={financialReportService.standardReportToAPIFilter}
      usePageFilter
    />
  ) : (
    <></>
  );
};

export default BalanceReportAssetsSummaryPieChart;
